import createHistory from 'history/createBrowserHistory'
import * as raf from 'raf'
import * as React from 'react'
import { hydrate, render } from 'react-dom'
import { AppContainer } from 'react-hot-loader'

import { clientFinishedLoading } from '../../common/actions/common'
import { getExperimentVariant } from '../../common/actions/experiments'
import experiments from '../../common/constants/experiments'
import { Site } from '../../common/constants/siteList'
import { IRootState } from '../../common/reducers'
import configureStore from '../../common/store/configureStore'
import legacyAffiliates from '../../common/utils/legacyAffiliates'
import AppV0 from '../v0/app'
import AppV1 from '../v1/app'

// V0 css
import '../../assets/stylesheets/compontents.css'
import '../../assets/stylesheets/core.css'
import '../../assets/stylesheets/search.css'
import '../../assets/stylesheets/style.css'

// V1 css
import '../v1/index.css'

const history = createHistory()

// this only runs on initial hydrating
const initialState = (window as any).INITIAL_STATE
delete (window as any).INITIAL_STATE

const store = configureStore(initialState, history)

legacyAffiliates(window.location)

hydrate(
  <AppContainer>
    <AppV0 store={store} history={history} />
  </AppContainer>,
  document.querySelector('#react-view')
)

const currentSite = store.getState().common.currentSite
if (currentSite === Site.videohive) {
  store.dispatch(getExperimentVariant(experiments.videohiveNewFilters))
} else if (currentSite === Site.graphicriver) {
  store.dispatch(getExperimentVariant(experiments.graphicriverNewFilters))
} else if (currentSite === Site.audiojungle) {
  store.dispatch(getExperimentVariant(experiments.audiojungleNewFilters))
}

const getVariant = (state: IRootState, experimentKey: string) => {
  const experimentId = experiments[experimentKey]
  const { variant } = state.experiments[experimentId]
  return parseInt(variant, 10)
}

// render client variant in next animation frame
raf(() => {
  const state = store.getState()
  const site = state.common.currentSite

  const showV0 =
    (site === Site.videohive && getVariant(state, 'videohiveNewFilters') < 2) ||
    (site === Site.graphicriver &&
      getVariant(state, 'graphicriverNewFilters') < 2) ||
    (site === Site.audiojungle &&
      getVariant(state, 'audiojungleNewFilters') < 2)

  if (showV0) {
    render(
      <AppContainer>
        <AppV0 store={store} history={history} />
      </AppContainer>,
      document.querySelector('#react-view'),
      () => {
        store.dispatch(clientFinishedLoading())
      }
    )
  } else {
    render(
      <AppContainer>
        <AppV1 store={store} history={history} />
      </AppContainer>,
      document.querySelector('#react-view'),
      () => {
        store.dispatch(clientFinishedLoading())
      }
    )
  }
})
